import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function CustomerBook() {
  const [hubs, setHubs] = useState([]);
  const [form, setForm] = useState({
    sender_name: '', sender_phone: '', pickup_address: '', pickup_hub_id: '',
    receiver_name: '', receiver_phone: '', delivery_address: '', destination_hub_id: '',
    description: '', declared_value: '', declared_weight_kg: '',
    delivery_option: 'hub_pickup', booking_fee: 50, delivery_fee: 20,
    booking_payment_method: 'momo',
  });
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const nav = useNavigate();

  useEffect(() => { api.get('/hubs').then(r => setHubs(r.data)); }, []);

  const upd = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async () => {
    setError('');
    if (!localStorage.getItem('sdx_token')) { nav('/login'); return; }
    try {
      const res = await api.post('/parcels', {
        ...form,
        pickup_hub_id: Number(form.pickup_hub_id),
        destination_hub_id: Number(form.destination_hub_id),
        booking_fee: Number(form.booking_fee),
        delivery_fee: Number(form.delivery_fee),
        declared_value: Number(form.declared_value) || 0,
        declared_weight_kg: Number(form.declared_weight_kg) || null,
      });
      setResult(res.data);
    } catch (e) { setError(e.response?.data?.error || 'Error'); }
  };

  if (result) {
    return (
      <div className="container">
        <div className="card" style={{ textAlign: 'center' }}>
          <h2 style={{ color: '#16a34a' }}>Parcel Booked ✓</h2>
          <p className="label">Tracking Number</p>
          <p style={{ fontSize: 22, fontWeight: 800, margin: 0 }}>{result.tracking_number}</p>
          <p className="label" style={{ marginTop: 16 }}>Pickup PIN (share with receiver)</p>
          <p style={{ fontSize: 28, fontWeight: 800, letterSpacing: 6, color: '#dc2626' }}>{result.pickup_pin}</p>
          <button className="btn btn-primary" onClick={() => nav(`/track/${result.tracking_number}`)}>Track this parcel</button>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <h2>Book a Parcel</h2>
        <h3 style={{ fontSize: 14, color: '#6b7280', marginTop: 20 }}>SENDER</h3>
        <label className="label">Name</label>
        <input className="input" value={form.sender_name} onChange={e => upd('sender_name', e.target.value)} />
        <label className="label">Phone</label>
        <input className="input" value={form.sender_phone} onChange={e => upd('sender_phone', e.target.value)} />
        <label className="label">Pickup Address</label>
        <input className="input" value={form.pickup_address} onChange={e => upd('pickup_address', e.target.value)} />
        <label className="label">Origin Hub</label>
        <select className="input" value={form.pickup_hub_id} onChange={e => upd('pickup_hub_id', e.target.value)}>
          <option value="">— select —</option>
          {hubs.map(h => <option key={h.id} value={h.id}>{h.name} ({h.city})</option>)}
        </select>

        <h3 style={{ fontSize: 14, color: '#6b7280', marginTop: 20 }}>RECEIVER</h3>
        <label className="label">Name</label>
        <input className="input" value={form.receiver_name} onChange={e => upd('receiver_name', e.target.value)} />
        <label className="label">Phone</label>
        <input className="input" value={form.receiver_phone} onChange={e => upd('receiver_phone', e.target.value)} />
        <label className="label">Destination Hub</label>
        <select className="input" value={form.destination_hub_id} onChange={e => upd('destination_hub_id', e.target.value)}>
          <option value="">— select —</option>
          {hubs.map(h => <option key={h.id} value={h.id}>{h.name} ({h.city})</option>)}
        </select>
        <label className="label">Delivery Option</label>
        <select className="input" value={form.delivery_option} onChange={e => upd('delivery_option', e.target.value)}>
          <option value="hub_pickup">Pickup at Hub (free)</option>
          <option value="home_delivery">Home Delivery (K{form.delivery_fee})</option>
        </select>
        {form.delivery_option === 'home_delivery' && (
          <>
            <label className="label">Delivery Address</label>
            <input className="input" value={form.delivery_address} onChange={e => upd('delivery_address', e.target.value)} />
          </>
        )}

        <h3 style={{ fontSize: 14, color: '#6b7280', marginTop: 20 }}>PARCEL</h3>
        <label className="label">Description</label>
        <input className="input" value={form.description} onChange={e => upd('description', e.target.value)} />
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ flex: 1 }}>
            <label className="label">Weight (kg)</label>
            <input className="input" type="number" value={form.declared_weight_kg} onChange={e => upd('declared_weight_kg', e.target.value)} />
          </div>
          <div style={{ flex: 1 }}>
            <label className="label">Declared Value (K)</label>
            <input className="input" type="number" value={form.declared_value} onChange={e => upd('declared_value', e.target.value)} />
          </div>
        </div>

        <h3 style={{ fontSize: 14, color: '#6b7280', marginTop: 20 }}>PAYMENT</h3>
        <label className="label">Booking Fee (K)</label>
        <input className="input" type="number" value={form.booking_fee} onChange={e => upd('booking_fee', e.target.value)} />
        <label className="label">Payment Method</label>
        <select className="input" value={form.booking_payment_method} onChange={e => upd('booking_payment_method', e.target.value)}>
          <option value="momo">MoMo</option>
          <option value="airtel">Airtel Money</option>
          <option value="cash">Cash to pickup rider</option>
        </select>

        <button className="btn btn-primary" style={{ width: '100%', padding: 14 }} onClick={submit}>Confirm Booking</button>
        {error && <p style={{ color: '#dc2626', marginTop: 12 }}>{error}</p>}
      </div>
    </div>
  );
}
